import styled from 'styled-components';

const Title = styled.span`
  font-weight: 700;
  font-size: 0.9rem;
  flex-grow: 1;
`;

export default Title;
